var cbtUtil = require("./cbtUtil");
var allPage = window.document.getElementsByClassName("cbt-all-pages");
var allPageDataLayer = allPage[0].getAttribute("data-cbt-all-pages");
var loggedUserData = window.document.getElementById("cbt-logged-user-data");
var loggedUserDataLayer = loggedUserData.getAttribute("data-logged-user");

loggedUserDataLayer = JSON.parse(loggedUserDataLayer);
allPageDataLayer = JSON.parse(allPageDataLayer);
var mergeDataLayer = Object.assign({}, allPageDataLayer, loggedUserDataLayer);

// Default Pageview
cbtUtil.dataPush(mergeDataLayer);

var pdpLoad = window.document.getElementsByClassName("cbt-pdp");
var pdpLoadDataLayer = pdpLoad[0].getAttribute("data-pdp-cbt");
pdpLoadDataLayer = JSON.parse(pdpLoadDataLayer);

// PDP - Page load
cbtUtil.dataPush(pdpLoadDataLayer);

var converisationRate = window.document.getElementsByClassName("cbt-confirmation-checkout");
var converisationRateDataLayer = converisationRate[0].getAttribute("data-confirmation-checkout");
converisationRateDataLayer = JSON.parse(converisationRateDataLayer);

// E-commerce - Conversion Rate
cbtUtil.dataPush(converisationRateDataLayer);

var cbtSearchResult = window.document.getElementsByClassName("cbt-search-result");
var searchResultLayer = cbtSearchResult.length ? cbtSearchResult[0].getAttribute("data-search-result-cbt") : null;
searchResultLayer = JSON.parse(searchResultLayer);

// Internal Search Engine - Interaction rate
cbtUtil.dataPush(searchResultLayer);

var cartLoad = window.document.getElementsByClassName("cbt-cart-products");
var cartLoadDataLayer = cartLoad[0].getAttribute("data-cart-cbt");
if (cartLoadDataLayer !== "") {
    cartLoadDataLayer = JSON.parse(cartLoadDataLayer);
}

// Products Array in Cart
cbtUtil.dataPush(cartLoadDataLayer);

// Pushes "gtm.js" event
/* global dataLayer */
dataLayer.push({
    "event": "gtm.js",
    "gtm.start": new Date().getTime()
});
